import DetailsPreview from './DetailsPreview/DetailsPreview';
import DetailsProfile from './DetailsProfile/DetailsProfile';
import DetailsSocialBenefits from './DetailsSocialBenefits/DetailsSocialBenefits';
import DetailsFinancialBenefits from './DetailsFinancialBenefits/DetailsFinancialBenefits';
import DetailsContributions from './DetailsContributions/DetailsContributions';
import DetailsDocuments from './DetailsDocuments/DetailsDocuments';
import DetailsTickets from './DetailsTickets/DetailsTickets';
import DetailsBookings from './DetailsBookings/DetailsBookings';
import DetailsPurchases from './DetailsPurchases/DetailsPurchases';

export const DetailsTabs = (setActiveTab: (tab: number) => void) => {
    return [
        {
            label: 'Aperçu',
            path: 'preview',
            component: <DetailsPreview setActiveTab={setActiveTab} />
        },
        {
            label: 'Profil adhérent',
            path: 'profile',
            component: <DetailsProfile />
        },
        {
            label: 'Documents',
            path: 'documents',
            component: <DetailsDocuments />
        },
        {
            label: 'Prestations sociales',
            path: 'social-benefits',
            component: <DetailsSocialBenefits />
        },
        {
            label: 'Prestations financières',
            path: 'financial-benefits',
            component: <DetailsFinancialBenefits />
        },
        {
            label: 'Cotisations',
            path: 'contributions',
            component: <DetailsContributions />
        },
        {
            label: 'Réservations',
            path: 'bookings',
            component: <DetailsBookings />
        },
        {
            label: 'Billetterie',
            path: 'tickets',
            component: <DetailsTickets />
        },
        {
            label: 'Achats e-billets',
            path: 'purchases',
            component: <DetailsPurchases />
        }
    ];
};
